import sendAnalyticsEvent from './sendAnalyticsEvent';
import MHelper from "./MHelper";
import setCookie from './setCookie';
import delayedEvents from './delayedEvents';

const cookieLifetime = 0.013889; // время жизни куки в днях

export default function interstitialObserver() {
  window.hashtag_watcher = window.hash_tag_watcher || setInterval(() => {
    if(!window.location.hash.includes('google_vignette')) return;
    clearInterval(window.hashtag_watcher);
    window.hashtag_watcher = null;
    sendAnalyticsEvent('INTERSTITIAL_AD_SHOW', { label: MHelper.orientation });

    setCookie("shownInterstitial", 1, cookieLifetime);
    delayedEvents().send();
  });
}
